// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import {
  BootstrapVue,
  IconsPlugin
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'
import jQuery from 'jquery'
import './bus';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Button from 'vue-js-toggle-button'
import CurrencyFilter from './filters/currency';
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import JsonCSV from 'vue-json-csv'
import VueClipboard from 'vue-clipboard2'
import JsonExcel from 'vue-json-excel'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import draggable from 'vuedraggable'
import Print from 'vue-print-nb'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

Vue.use(VueSidebarMenu)
Vue.use(Print);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.component('downloadExcel', JsonExcel)
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.component('downloadCsv', JsonCSV)
Vue.use(VueQuillEditor)

Vue.component('Loading',Loading);
Vue.use(Button);
Vue.filter('currency', CurrencyFilter);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false


// axios.defaults.withCredentials=true;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: {
    App,
  },
  template: '<App/>',
  router,
});

router.beforeEach((to, from, next) => {
  // ...
  if (to.meta.requiresAuth) {
    let token = window.localStorage.getItem('usertoken')
    let token2 = window.localStorage.getItem('usertokenMaximumAuthority')
    if (to.matched.some(item => item.meta.requiresAuth) && ((!token || token === null) && (!token2 || token2 === null)) ) {
      next({
        path: '/login',
      })
    }else {
      next()
    }

  } else {
    next();
  }



});

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})





// WEBPACK FOOTER //
// ./src/main.js